import _inherits from "/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _classCallCheck from "/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/data/var/lib/jenkins/workspace/AFM-Portal-Prod-CustomerEngage_AccountManagement_warfilebuild/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import * as log from '../../log';
import { uniqueId } from '../../util';
/**
 * A node in the dataflow tree.
 */

export var DataFlowNode = /*#__PURE__*/function () {
  function DataFlowNode(parent, debugName) {
    _classCallCheck(this, DataFlowNode);

    this.debugName = debugName;
    this._children = [];
    this._parent = null;

    if (parent) {
      this.parent = parent;
    }
  }
  /**
   * Clone this node with a deep copy but don't clone links to children or parents.
   */


  _createClass(DataFlowNode, [{
    key: "clone",
    value: function clone() {
      throw new Error('Cannot clone node');
    }
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
    /**
     * Set the parent of the node and also add this node to the parent's children.
     */
    ,
    set: function set(parent) {
      this._parent = parent;

      if (parent) {
        parent.addChild(this);
      }
    }
  }, {
    key: "children",
    get: function get() {
      return this._children;
    }
  }, {
    key: "numChildren",
    value: function numChildren() {
      return this._children.length;
    }
  }, {
    key: "addChild",
    value: function addChild(child, loc) {
      // do not add the same child twice
      if (this._children.indexOf(child) > -1) {
        log.warn(log.message.ADD_SAME_CHILD_TWICE);
        return;
      }

      if (loc !== undefined) {
        this._children.splice(loc, 0, child);
      } else {
        this._children.push(child);
      }
    }
  }, {
    key: "removeChild",
    value: function removeChild(oldChild) {
      var loc = this._children.indexOf(oldChild);

      this._children.splice(loc, 1);

      return loc;
    }
    /**
     * Remove node from the dataflow.
     */

  }, {
    key: "remove",
    value: function remove() {
      var loc = this._parent.removeChild(this);

      var _iterator = _createForOfIteratorHelper(this._children),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var child = _step.value;
          // do not use the set method because we want to insert at a particular location
          child._parent = this._parent;

          this._parent.addChild(child, loc++);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
    /**
     * Insert another node as a parent of this node.
     */

  }, {
    key: "insertAsParentOf",
    value: function insertAsParentOf(other) {
      var parent = other.parent;
      parent.removeChild(this);
      this.parent = parent;
      other.parent = this;
    }
  }, {
    key: "swapWithParent",
    value: function swapWithParent() {
      var parent = this._parent;
      var newParent = parent.parent; // reconnect the children

      var _iterator2 = _createForOfIteratorHelper(this._children),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var child = _step2.value;
          child.parent = parent;
        } // remove old links

      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      this._children = []; // equivalent to removing every child link one by one

      parent.removeChild(this);
      parent.parent.removeChild(parent); // swap two nodes

      this.parent = newParent;
      parent.parent = this;
    }
  }]);

  return DataFlowNode;
}();
export var OutputNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(OutputNode, _DataFlowNode);

  var _super = _createSuper(OutputNode);

  /**
   * @param source The name of the source. Will change in assemble.
   * @param type The type of the output node.
   * @param refCounts A global ref counter map.
   */
  function OutputNode(parent, source, type, refCounts) {
    var _this;

    _classCallCheck(this, OutputNode);

    _this = _super.call(this, parent, source);
    _this.type = type;
    _this.refCounts = refCounts;
    _this._source = _this._name = source;

    if (_this.refCounts && !(_this._name in _this.refCounts)) {
      _this.refCounts[_this._name] = 0;
    }

    return _this;
  }

  _createClass(OutputNode, [{
    key: "clone",
    value: function clone() {
      var cloneObj = new this.constructor();
      cloneObj.debugName = 'clone_' + this.debugName;
      cloneObj._source = this._source;
      cloneObj._name = 'clone_' + this._name;
      cloneObj.type = this.type;
      cloneObj.refCounts = this.refCounts;
      cloneObj.refCounts[cloneObj._name] = 0;
      return cloneObj;
    }
  }, {
    key: "dependentFields",
    value: function dependentFields() {
      return new Set();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return new Set();
    }
  }, {
    key: "hash",
    value: function hash() {
      if (this._hash === undefined) {
        this._hash = "Output ".concat(uniqueId());
      }

      return this._hash;
    }
    /**
     * Request the datasource name and increase the ref counter.
     *
     * During the parsing phase, this will return the simple name such as 'main' or 'raw'.
     * It is crucial to request the name from an output node to mark it as a required node.
     * If nobody ever requests the name, this datasource will not be instantiated in the assemble phase.
     *
     * In the assemble phase, this will return the correct name.
     */

  }, {
    key: "getSource",
    value: function getSource() {
      this.refCounts[this._name]++;
      return this._source;
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      return !!this.refCounts[this._name];
    }
  }, {
    key: "setSource",
    value: function setSource(source) {
      this._source = source;
    }
  }]);

  return OutputNode;
}(DataFlowNode);